export default __webpack_public_path__ + "svg/calendar/2027/1/febrero.svg?f329a93f";